import {
  FETCH_AV_ALTERNATIVES_REQUEST,
  FETCH_AV_ALTERNATIVES_SUCCESS,
  FETCH_AV_ALTERNATIVES_FAILURE,
  UPDATE_AV_ALTERNATIVES
} from '../../actionTypes/avAlternativesActionTypes'

const fetchAvAlternativesRequest = payload => {
  const { partNumber, localisation = {}, categoryId, type } = payload
  const action = {
    type: FETCH_AV_ALTERNATIVES_REQUEST,
    payload: {
      type,
      partNumber,
      localisation,
      categoryId
    }
  }
  return action
}

const fetchAvAlternativesSuccess = payload => {
  const action = {
    type: FETCH_AV_ALTERNATIVES_SUCCESS,
    payload
  }
  return action
}

const fetchAvAlternativesFailure = ({ partNumber, errorDetail }) => {
  const action = {
    type: FETCH_AV_ALTERNATIVES_FAILURE,
    payload: { partNumber, errorDetail: errorDetail.toString() }
  }
  return action
}

const updateAvAlternatives = payload => {
  const action = {
    type: UPDATE_AV_ALTERNATIVES,
    payload
  }
  return action
}

export { fetchAvAlternativesRequest, fetchAvAlternativesSuccess, fetchAvAlternativesFailure, updateAvAlternatives }
